import { provideAuthInitializer } from '@yoshu-lib/core/auth/auth-initializer.factory'

import { provideCotyAuthService } from './config/auth-service.provider'
import { provideCotyAuthStore } from './config/auth-store.provider'
import { provideEnvironment } from './config/environment.provider'

export const provideCore = () => [
  provideAuthInitializer(),
  provideEnvironment(),
  provideCotyAuthService(),
  provideCotyAuthStore()
]
